import React, { useState, useEffect, useRef, useCallback } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Creators as NotificationsActions } from "../../store/ducks/notifications/actions"
import NotificacaoItem from "./NotificacaoItem"
import { useDarkMode } from "../../hooks/useDarkMode"
import * as Styles from "./styles"

const Notificacao = ({ notification, showNotes, countNotif, getNotificationRequest, hide }) => {
  const [notificationsAsNotRead, setNotificationsAsNotRead] = useState([])
  const [isMounted, setIsMounted] = useState(true)
  const isDarkMode = useDarkMode()
  const wrapperRef = useRef(null)
  const notificationRef = useRef(null)

  useEffect(() => {
    if (isMounted) {
      getNotificationRequest("navbar")
    }
    
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        hide()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    
    return () => {
      setIsMounted(false)
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [isMounted, getNotificationRequest, hide])

  const updateList = useCallback(() => {
    if (isMounted) {
      getNotificationRequest("navbar")
    }
  }, [isMounted, getNotificationRequest])

  const markReads = async () => {
    // TODO implementar no ms
  }

  const countReadNotif = useCallback((idNotification) => {
    if (isMounted) {
      setNotificationsAsNotRead(prev => [...prev, idNotification])
    }
  }, [isMounted])

  return (
    <Styles.NotificacaoContainer darkMode={isDarkMode}> 
      <div id="notifications-navBarSuperior" style={showNotes} ref={wrapperRef}>
        <Styles.TriangleUp />
        <div className="notifications-container">
          <div className="notifications-header px-3">
            <p className="notifications-title">Notificações</p>
            <div>
              <div
                style={{ fontSize: "14px" }}
                className="btn btn-outline-primary btn-small mr-2"
                onClick={markReads}
                role="button"
              >
                <p>Marcar todos como lidas</p>
              </div>
              <Link
                className="btn btn-outline-primary btn-small"
                style={{ fontSize: "14px" }}
                to="/notificacoes"
              >
                <p>Ver todos <i className="fa fa-angle-right" aria-hidden="true" /></p>
              </Link>
            </div>
          </div>
          <div className="notifications-content">
            <div
              className="text-right mr-3 mb-1"
              style={{
                borderBottomWidth: "1px",
                borderBottomColor: "#cdcdcd",
                borderBottomStyle: "solid",
              }}
            />
            {notification.length > 0 ? (
              notification.map((item, index) => {
                return (
                  <NotificacaoItem
                    key={index}
                    ref={notificationRef}
                    item={item}
                    first={index === 0}
                    countNotif={countNotif}
                    updateList={updateList}
                    countMarkRead={countReadNotif}
                  />
                )
              })
            ) : (
              <p className="notifications-empty">
                Você não possui notificações no momento.
              </p>
            )}
          </div>
        </div>
      </div>
    </Styles.NotificacaoContainer>
  )
}

const mapStateToProps = store => {
  return {
    notification: store.notifications.data,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators(NotificationsActions, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notificacao)
